import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import m from '@utils/strings';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomSnackbar from '../../shared/custom_snackbar'

export default class ExameEmAnalise extends Component {

    onCopiarClick = ({ target: { innerHTML } }) => {
        this.clickChild()
    }

    onCopy = () => {
        this.setState({ copied: true });
    }

    render() {

        let { exameResultado } = this.props;

        return (
            <div style={{ marginBottom: 5 }}>
                <div className={"div-area-resultado-autorizacao"} style={{ marginLeft: 50, marginTop: 15 }}>
                    <label id={"label-erro-servico"}>
                        {m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_ATENDIMENTO_EM_ANALISE}
                    </label>
                    <img
                        src="../images/info.png"
                        alt="info"
                        title={m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_ACOMPANHAR_SOLICITACAO}
                        style={{
                            marginRight: 10,
                            marginLeft: 10,
                            width: 13,
                            marginTop: -15
                        }}
                    />
                    <label
                        inline={true}
                        style={{ color: '#00885F', fontFamily: 'Source Code Pro', fontSize: 16, fontWeight: 500, marginLeft: 15, marginTop: 15, cursor: 'pointer' }}
                        onClick={this.props.displayAutorizacaoResultTable}
                    >
                        {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_MOSTRAR_DETALHES}
                    </label>
                </div>
                <div className={"div-separador-top-10"} style={{ marginLeft: 100, marginTop: 25 }}>
                    <label id={"label-senha"}>{m.TELA_EXAMES_PROCEDIMENTOS.LABEL_GUIA}</label>
                </div>
                <div className={"div-separador-top-10"} style={{ marginLeft: 100 }}>
                    <label id={"label-senha-numero"} style={{ fontFamily: 'Source Code Pro', fontWeight: 700, fontSize: 20 }}>
                        {exameResultado.data.SolicitacaoProcedimento.NumeroGuiaOperadora}
                    </label>
                    <div className={"div-separador-top-10"}>
                        {<CopyToClipboard text={exameResultado.data.SolicitacaoProcedimento.NumeroGuiaOperadora}
                            onCopy={this.onCopy}>
                            <label onClick={this.dispatchGuiaSnackbar} id={"label-copiar"}>{m.TELA_EXAMES_PROCEDIMENTOS.LABEL_COPIAR}</label>
                        </CopyToClipboard>}
                    </div>
                </div>
                <div className={"div-separador-top-bottom-25"}>
                    <hr className={"hr-class"} style={{ marginLeft: 101, marginRight: 458 }} />
                </div>
                <div className={"div-separador-top-10"}>
                    {<Button
                        onClick={() => {
                            this.props.resetAllStates();
                        }}
                        className={"btn-default-cemig"}
                        style={{ marginLeft: 115 }}
                    >
                        {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_NOVO_ATENDIMENTO} (ENTER)
                        </Button>}
                </div>
                <CustomSnackbar
                    setClick={click => this.dispatchGuiaSnackbar = click}
                    variant="success"
                    duration={1000}
                    content={m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_COPIAR_GUIA}
                />
            </div>
        );
    }
}